import React from 'react';
import { RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNotifications } from '@/hooks/useNotifications';

export const NotificationRefreshButton: React.FC = () => {
  const { checkSmartNotifications, isCheckingSmartNotifications } = useNotifications();

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={checkSmartNotifications}
      disabled={isCheckingSmartNotifications}
      className="text-xs gap-1"
    >
      <RefreshCw className={`h-3 w-3 ${isCheckingSmartNotifications ? 'animate-spin' : ''}`} />
      {isCheckingSmartNotifications ? 'Verificando...' : 'Actualizar'}
    </Button>
  );
};